import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import NotificationBox from '../components/NotificationBox';
import { changePassword, authenticateUser } from '../service/auth';

const LoginStyles = makeStyles({
  pageContainer: {
    margin: '20px',
    marginLeft: '90px',
    paddingBottom: '20px',
  },
  form: {
    maxWidth: '350px',
  },
  label: {
    lineHeight: '2',
    textAlign: 'left',
    display: 'block',
    marginBottom: '13px',
    marginTop: '20px',
    color: 'black',
    fontSize: '16px',
    fontWeight: '700',
  },
  submitButtonContainer: {
    display: 'flex',
    width: '1000px !important',
  },
  submitButton: {
    display: 'block',
    background: 'orange',
    color: 'white',
    textTransform: 'uppercase',
    cursor: 'pointer',
    border: 'none',
    marginTop: '20px',
    marginRight: '20px',
    padding: '15px',
    fontSize: '18px',
    fontWeight: '600',
  },
  inputBox: {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    borderRadius: '4px',
    border: '1px solid black',
    padding: '10px 15px',
    marginBottom: '10px',
    fontSize: '16px',
  },
  errorInfo: {
    color: 'red',
  },
});

const ChangePassword = ({ history }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const userLoggedIn = authenticateUser();
  if (!userLoggedIn) {
    history.push('/login');
  }
  const [state, setState] = useState({});
  const classes = LoginStyles();

  const onSubmit = async (userData, e) => {
    const userObj = localStorage.getItem('QBUser');
    const user = JSON.parse(userObj);
    const user_id = user?.id;
    const changePasswordData = {
      id: user_id,
      currentPassword: userData.currentPassword,
      newPassword: userData.newPassword,
      confirmNewPassword: userData.confirmNewPassword,
    };

    if (
      changePasswordData.newPassword !== changePasswordData.confirmNewPassword
    ) {
      alert('new password and confirm new password must be same!');
      return false;
    }

    const res = await changePassword(changePasswordData);
    if (res.data.success) {
      // set user info into local storage
      localStorage.setItem('QBUser', JSON.stringify(res.data.user));
      setState({
        ...state,
        successInfo: 'Password changed successfully',
        successPopup: true,
      });
      history.push('/questions');
    } else {
      if (res.data == null) {
        setState({
          ...state,
          errorInfo: 'Error with change password, please try again.',
          errorPopup: true,
        });
        return;
      }
      setState({
        ...state,
        errorInfo: res.data.errorMessage,
        errorPopup: true,
      });
    }
  };

  const handleSuccessPopupClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setState({
      ...state,
      successPopup: false,
    });
  };

  const handleErrorPopupClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setState({
      ...state,
      errorPopup: false,
    });
  };

  const successPopupBox = (
    <NotificationBox
      isOpen={state.successPopup}
      OnCloseHandler={handleSuccessPopupClose}
      alertType="success"
      alertMessage={state.successInfo}
    />
  );

  const errorPopupBox = (
    <NotificationBox
      isOpen={state.errorPopup}
      OnCloseHandler={handleErrorPopupClose}
      alertType="error"
      alertMessage={state.errorInfo}
    />
  );

  return (
    <div
      className={classes.pageContainer}
      success={state.formSuccess}
      error={state.formError}
    >
      {successPopupBox}
      {errorPopupBox}

      <h3>
        Change your password for the Computer Science Quiz Question Bank account
      </h3>

      <p>
        Please enter your new password below. New password must be at least 8
        characters long.
      </p>

      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <label className={classes.label}>Current Password</label>
        <input
          className={classes.inputBox}
          type="password"
          {...register('currentPassword', { required: true })}
        />
        {errors?.currentPassword?.type === 'required' && (
          <em className={classes.errorInfo}>
            Please enter your current password
          </em>
        )}

        <label className={classes.label}>New Password</label>
        <input
          className={classes.inputBox}
          type="password"
          {...register('newPassword', { required: true, minLength: 8 })}
        />
        {errors?.newPassword?.type === 'required' && (
          <em className={classes.errorInfo}>Please enter your new password</em>
        )}
        {errors?.newPassword?.type === 'minLength' && (
          <em className={classes.errorInfo}>
            New password must be at least 8 characters long
          </em>
        )}

        <label className={classes.label}>Confirm New Password</label>
        <input
          className={classes.inputBox}
          type="password"
          {...register('confirmNewPassword', {
            required: true,
          })}
        />
        {errors?.confirmNewPassword?.type === 'required' && (
          <em className={classes.errorInfo}>
            Please re-type your new password
          </em>
        )}
        {state.passwordMatch === false && (
          <em className={classes.errorInfo}>
            Please re-type your new password
          </em>
        )}
        <div className={classes.submitButtonContainer}>
          <button
            className={classes.submitButton}
            type="submit"
            onClick={handleSubmit}
          >
            Change Password
          </button>
          <p>
            Don't remember your current password? Logout and then reset your
            password using Forgot Password
          </p>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
